// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__3r2Jt","buscador":"Formulario_buscador__3cW0-","btn_block":"Formulario_btn_block__15GIm"};